export default {
  label: 'Largura',
};
